import { getFirebaseClientAuth } from "@/lib/firebase-client-config";
import { User } from "firebase/auth";

export async function getUserLogged(): Promise<User | null> {
    console.log('getUserLogged')
    const firebaseClientAuth = await getFirebaseClientAuth();
    if (!firebaseClientAuth) {
        throw new Error('firebaseClientAuth is null');
    }
    return firebaseClientAuth.currentUser;
}

export async function isUserLogged(): Promise<boolean> {
    console.log('isUserLogged')
    const currentUser = await getUserLogged()
    if (currentUser) {
        return !currentUser.isAnonymous;
    }
    return false
}
